export default __webpack_public_path__ + "static/media/dominos-grey.b5c9b1ea.mp4";